import DashboardLayout from "layouts/DashboardLayout";
import React, { useEffect, useState } from "react";
import { userData } from "utils/userData";
import GaugeChart from "react-gauge-chart";
import styled from "styled-components";
import { AiOutlineDown /* AiOutlineStar */ } from "react-icons/ai";
//import Analysis from "chartPages/Analysis";
//import Analysis from "chartPages/Analysis";
import { ApiService } from "services";
import { toast } from "react-hot-toast";
import { FormInput } from "components";
import { handleCheckMetric } from "utils/handleMetricsChekc";
import Skeleton2 from "components/Skeleton2";
export default function ResponseTime() {
  console.log(userData);
  //eslint-disable-next-line
  const color = "#200E32";
  //eslint-disable-next-line

  //eslint-disable-next-line
  const [searchInput, setSearchInput] = useState("");
  const savedData = JSON.parse(localStorage.getItem("responseTime"));

  const [secondsEnter, setSecondsEnter] = useState(
    Number(savedData?.seconds || 300)
  );
  const [secondsEnter2, setSecondsEnter2] = useState(
    Number(savedData?.seconds || 300)
  );
  const [secondsOpen, setSecondsOpen] = useState(false);

  const [loading, setLoading] = useState(false);

  const [dashboardData, setDashboardData] = useState();

  useEffect(() => {
    localStorage.setItem(
      "responseTime",
      JSON.stringify({
        dashboardData: dashboardData || savedData?.dashboardData,
        seconds: secondsEnter2,
      })
    );

    //eslint-disable-next-line
  }, [dashboardData]);

  //eslint-disable-next-line
  const [dateFrom, setDateFrom] = useState();
  //eslint-disable-next-line
  const [dateTo, setDateTo] = useState();

  /* MAIN DASH */

  const getDashboardAnalysis = async (param) => {
    setLoading(true);
    if (
      userData?.userDetail?.role === "chiefAdmin" ||
      userData?.userDetail?.role === "subAdmin1" ||
      userData?.userDetail?.role === "subAdmin2"
    ) {
      try {
        const data = await ApiService.getDashboardAnalysis(param);
        setLoading(false);
        setDashboardData(data?.data);
      } catch (err) {
        setLoading(false);
        console.log(err);
        if (err?.message === "It's not you, it's us. Try again later.") {
        } else if (err?.message === "Network Error") {
          return;
        } else {
          toast.error(err?.response?.data?.message || err?.message);
        }
      }
    }
  };

  const getDashboardAnalysis2 = async (param) => {
    if (
      userData?.userDetail?.role === "chiefAdmin" ||
      userData?.userDetail?.role === "subAdmin1" ||
      userData?.userDetail?.role === "subAdmin2"
    ) {
      setLoading(true);
      setSecondsOpen(false);
      setDateFilter(false);

      try {
        const data = await ApiService.getDashboardAnalysis(param);
        setDashboardData(data?.data);
        setLoading(false);
      } catch (err) {
        console.log(err);
        if (err?.message === "It's not you, it's us. Try again later.") {
        } else if (err?.message === "Network Error") {
          return;
        } else {
          toast.error(err?.response?.data?.message || err?.message);
        }
      }
      setLoading(false);
    }
  };

  const getDashboardAnalysisLoad = async (param) => {
    if (
      userData?.userDetail?.role === "chiefAdmin" ||
      userData?.userDetail?.role === "subAdmin1" ||
      userData?.userDetail?.role === "subAdmin2"
    ) {
      try {
        const data = await ApiService.getDashboardAnalysis(param);
        setDashboardData(data?.data);
      } catch (err) {
        console.log(err);
        if (err?.message === "It's not you, it's us. Try again later.") {
        } else if (err?.message === "Network Error") {
          return;
        } else {
          toast.error(err?.response?.data?.message || err?.message);
        }
      }
    }
  };

  const siteAnalytics =
    dashboardData?.[0] || savedData?.dashboardData?.[0] || {};

  const sitePerformanceIndicator =
    siteAnalytics?.sitePerformanceIndicator || [];

  //eslint-disable-next-line
  const [ipDuration, setIpDuration] = useState("daily");
  const [institutionType, setInstitutionType] = useState("");

  //eslint-disable-next-line
  const [dateFilter, setDateFilter] = useState(false);

  useEffect(() => {
    if (savedData) {
      return;
    } else {
      getDashboardAnalysis(
        `?reportType=indicator&indicatorLastPeriod=${secondsEnter}`
      );
    }

    //eslint-disable-next-line
  }, []);

  function formatTime(seconds) {
    return [
      seconds / 60 / 60 / 24 >= 1
        ? `${parseInt(seconds / 60 / 60 / 24)}d `
        : "",
      seconds / 60 / 60 < 24
        ? seconds / 60 / 60 === 0
          ? ""
          : `${parseInt(seconds / 60 / 60)}h `
        : "",
      (seconds / 60) % 60 !== 0 ? `${parseInt((seconds / 60) % 60)}m ` : "",
      seconds % 60 !== 0 ? `${parseInt(seconds % 60)}s` : "",
    ]
      .join("")
      .replace(/\b(\d)\b/g, "0$1");
  }
  const ipDurate = ipDuration;
  useEffect(() => {
    const interval = setInterval(() => {
      if (userData?.userDetail?.role === "chiefAdmin") {
        getDashboardAnalysisLoad(
          `?reportType=indicator&indicatorLastPeriod=${secondsEnter}`
        );
      }
    }, secondsEnter2 * 1000);
    return () => clearInterval(interval);

    //eslint-disable-next-line
  }, [secondsEnter2, ipDurate]);

  return (
    <DashboardLayout>
      {userData?.userDetail?.role === "chiefAdmin" && (
        <>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "flex-start",
            }}
          >
            <Head>
              <div className="top">
                <p style={{ margin: 0 }}>Site Performance Indicator</p>
              </div>
            </Head>
            <SelectInput name="" id="">
              <select
                onChange={(e) => {
                  getDashboardAnalysis(
                    `?institutionType=${e.target.value}${
                      dateFrom && dateTo
                        ? `${`&dateFrom=${dateFrom}&dateTo=${dateTo}`}`
                        : ""
                    }&indicatorLastPeriod=${secondsEnter}&reportType=indicator`
                  );

                  setInstitutionType(e.target.value);
                }}
              >
                <option value="" selected>
                  All
                </option>
                <option value="bank">Bank Institutions</option>
                <option value="nonBank">Non-Bank Institutions</option>
              </select>
              <svg
                className="icon"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M8.69891 11.4136L11.2385 14.0036C11.6209 14.3936 12.2386 14.3936 12.621 14.0036L15.1606 11.4136C15.7783 10.7836 15.3371 9.70361 14.4644 9.70361H9.38528C8.51261 9.70361 8.08117 10.7836 8.69891 11.4136Z"
                  fill="#019EDF"
                />
              </svg>
            </SelectInput>
          </div>
          <Head>
            <div className="top">
              <span>Today, {formatTime(secondsEnter2)} ago</span>
            </div>
            <div className="timerate">
              <span
                onClick={() => {
                  setSecondsOpen(!secondsOpen);
                  setDateFilter(false);
                }}
                style={{ position: "relative", cursor: "pointer" }}
              >
                Filter By Last {secondsEnter} Seconds <AiOutlineDown />
                {secondsOpen && (
                  <DropDown
                    onClick={(e) => {
                      e.stopPropagation();
                    }}
                    style={{ cursor: "default", width: "300px" }}
                  >
                    <div className="title" style={{ padding: "10px 0" }}>
                      Fetch Time Frame
                    </div>
                    <form
                      onSubmit={() => {
                        if (secondsEnter >= 300) {
                          getDashboardAnalysis2(
                            `?indicatorLastPeriod=${secondsEnter}${
                              institutionType
                                ? `&institutionType=${institutionType}`
                                : ""
                            }&reportType=indicator`
                          );

                          setSecondsEnter2(secondsEnter);
                        } else {
                          toast.error("Must not be less than 15 seconds");
                        }
                      }}
                    >
                      <FormInput
                        onChange={(e) => {
                          setSecondsEnter(e.target.value);
                        }}
                        type="number"
                        background="#F2F7FF"
                        padding="10px 14px"
                        placeholder="Enter Seconds"
                      />
                    </form>
                    <svg
                      style={{
                        position: "absolute",
                        top: "50%",
                        right: "30px",
                        transform: "translateY(50%)",
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        if (secondsEnter >= 300) {
                          getDashboardAnalysis2(
                            `?institutionType=${institutionType}&indicatorLastPeriod=${secondsEnter}&reportType=indicator`
                          );

                          setSecondsEnter2(secondsEnter);
                        } else {
                          toast.error("Must not be less than 15 seconds");
                        }
                      }}
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g clip-path="url(#clip0_505_4722)">
                        <path
                          d="M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z"
                          fill="#00B3FE"
                        />
                        <path
                          d="M15.1196 9.12419C13.979 7.98365 12.8387 6.84311 11.6981 5.70258C10.6189 4.62314 8.95014 6.30466 10.0321 7.38663C10.497 7.85149 10.9619 8.31638 11.4267 8.78141C9.59614 8.78141 7.76556 8.78141 5.93516 8.78141C4.40556 8.78141 4.39213 11.1506 5.9181 11.1506C7.7545 11.1506 9.5909 11.1506 11.4272 11.1506C10.9592 11.6186 10.4911 12.0866 10.0231 12.5547C8.94368 13.6339 10.6252 15.3027 11.7072 14.2207C12.8477 13.0803 13.9881 11.94 15.1286 10.7994C15.5865 10.3413 15.574 9.57849 15.1196 9.12419Z"
                          fill="white"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_505_4722">
                          <rect width="20" height="20" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                  </DropDown>
                )}
              </span>
            </div>
          </Head>
          <Head>
            <div
              className="top"
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "100%",
              }}
            >
              <p style={{ margin: "10px 0" }}>Response Time</p>
            </div>
          </Head>
          {loading ? (
            <Skeleton2 />
          ) : (
            sitePerformanceIndicator && (
              <GaugeStyle>
                {sitePerformanceIndicator?.map((item) => {
                  return (
                    <div className="gauge">
                      <GaugeChart
                        id="gauge-chart3"
                        nrOfLevels={30}
                        colors={["#37ffa8", "#FFC371", "#EA4228"]}
                        arcWidth={0.3}
                        style={{ width: "100%" }}
                        textColor="#fd9c0a0"
                        hideText={true}
                        percent={
                          item?.averageSec > 45 ? 45 : item?.averageSec / 45
                        }
                      />
                      <div className="gauge_sec">{item?.averageSec}s</div>
                      <div className="gauge_text">{item?.institution}</div>
                    </div>
                  );
                })}
              </GaugeStyle>
            )
          )}
          <div
            style={{ color: "#a7a7a7", marginBottom: "40px", fontSize: "16px" }}
          >
            {loading ? (
              <Skeleton2 height="30px" />
            ) : (
              sitePerformanceIndicator?.length === 0 && "No Response Time Data"
            )}
          </div>
        </>
      )}

      {userData?.userDetail?.role === "subAdmin1" && (
        <>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "flex-start",
            }}
          >
            <Head>
              <div className="top">
                <p style={{ margin: 0 }}>Site Performance Indicator</p>
              </div>
            </Head>
            <SelectInput name="" id="">
              <select
                onChange={(e) => {
                  getDashboardAnalysis(
                    `?institutionType=${e.target.value}&dateFrom=${dateFrom}&dateTo=${dateTo}&indicatorLastPeriod=${secondsEnter}&reportType=indicator`
                  );

                  setInstitutionType(e.target.value);
                }}
              >
                <option value="" selected>
                  All
                </option>
                <option value="bank">Bank Institutions</option>
                <option value="nonBank">Non-Bank Institutions</option>
              </select>
              <svg
                className="icon"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M8.69891 11.4136L11.2385 14.0036C11.6209 14.3936 12.2386 14.3936 12.621 14.0036L15.1606 11.4136C15.7783 10.7836 15.3371 9.70361 14.4644 9.70361H9.38528C8.51261 9.70361 8.08117 10.7836 8.69891 11.4136Z"
                  fill="#019EDF"
                />
              </svg>
            </SelectInput>
          </div>
          <Head>
            <div className="top">
              <span>Today, {formatTime(secondsEnter2)} ago</span>
            </div>
            <div className="timerate">
              <span
                onClick={() => {
                  setSecondsOpen(!secondsOpen);
                  setDateFilter(false);
                }}
                style={{ position: "relative", cursor: "pointer" }}
              >
                Filter By Last {secondsEnter} Seconds <AiOutlineDown />
                {secondsOpen && (
                  <DropDown
                    onClick={(e) => {
                      e.stopPropagation();
                    }}
                    style={{ cursor: "default", width: "300px" }}
                  >
                    <div className="title" style={{ padding: "10px 0" }}>
                      Fetch Time Frame
                    </div>
                    <form
                      onSubmit={() => {
                        if (secondsEnter >= 300) {
                          getDashboardAnalysis2(
                            `?indicatorLastPeriod=${secondsEnter}${
                              institutionType
                                ? `&institutionType=${institutionType}`
                                : ""
                            }&reportType=indicator`
                          );

                          setSecondsEnter2(secondsEnter);
                        } else {
                          toast.error("Must not be less than 15 seconds");
                        }
                      }}
                    >
                      <FormInput
                        onChange={(e) => {
                          setSecondsEnter(e.target.value);
                        }}
                        type="number"
                        background="#F2F7FF"
                        padding="10px 14px"
                        placeholder="Enter Seconds"
                      />
                    </form>
                    <svg
                      style={{
                        position: "absolute",
                        top: "50%",
                        right: "30px",
                        transform: "translateY(50%)",
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        if (secondsEnter >= 300) {
                          getDashboardAnalysis2(
                            `?institutionType=${institutionType}&indicatorLastPeriod=${secondsEnter}&reportType=indicator`
                          );

                          setSecondsEnter2(secondsEnter);
                        } else {
                          toast.error("Must not be less than 15 seconds");
                        }
                      }}
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g clip-path="url(#clip0_505_4722)">
                        <path
                          d="M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z"
                          fill="#00B3FE"
                        />
                        <path
                          d="M15.1196 9.12419C13.979 7.98365 12.8387 6.84311 11.6981 5.70258C10.6189 4.62314 8.95014 6.30466 10.0321 7.38663C10.497 7.85149 10.9619 8.31638 11.4267 8.78141C9.59614 8.78141 7.76556 8.78141 5.93516 8.78141C4.40556 8.78141 4.39213 11.1506 5.9181 11.1506C7.7545 11.1506 9.5909 11.1506 11.4272 11.1506C10.9592 11.6186 10.4911 12.0866 10.0231 12.5547C8.94368 13.6339 10.6252 15.3027 11.7072 14.2207C12.8477 13.0803 13.9881 11.94 15.1286 10.7994C15.5865 10.3413 15.574 9.57849 15.1196 9.12419Z"
                          fill="white"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_505_4722">
                          <rect width="20" height="20" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                  </DropDown>
                )}
              </span>
            </div>
          </Head>

          {handleCheckMetric(
            "sitePerformance",
            userData?.userDetail?.metrics
          ) && (
            <>
              <Head>
                <div
                  className="top"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    width: "100%",
                  }}
                >
                  <p style={{ margin: "10px 0" }}>Response Time</p>
                </div>
              </Head>{" "}
              {loading && <Skeleton2 height="30px" />}
              {loading ? (
                <Skeleton2 />
              ) : (
                sitePerformanceIndicator && (
                  <GaugeStyle>
                    {sitePerformanceIndicator?.map((item) => {
                      return (
                        <div className="gauge">
                          <GaugeChart
                            id="gauge-chart3"
                            nrOfLevels={30}
                            colors={["#37ffa8", "#FFC371", "#EA4228"]}
                            arcWidth={0.3}
                            style={{ width: "100%" }}
                            textColor="#fd9c0a0"
                            hideText={true}
                            percent={
                              item?.averageSec > 45 ? 45 : item?.averageSec / 45
                            }
                          />
                          <div className="gauge_sec">{item?.averageSec}s</div>
                          <div className="gauge_text">{item?.institution}</div>
                        </div>
                      );
                    })}
                  </GaugeStyle>
                )
              )}
              <div
                style={{
                  color: "#a7a7a7",
                  marginBottom: "40px",
                  fontSize: "16px",
                }}
              >
                {loading ? (
                  <Skeleton2 height="30px" />
                ) : (
                  sitePerformanceIndicator?.length === 0 &&
                  "No Response Time Data"
                )}
              </div>
            </>
          )}
        </>
      )}
      {userData?.userDetail?.role === "subAdmin2" && (
        <>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "flex-start",
            }}
          >
            <Head>
              <div className="top">
                <p style={{ margin: 0 }}>Site Performance Indicator</p>
              </div>
            </Head>
            <SelectInput name="" id="">
              <select
                onChange={(e) => {
                  getDashboardAnalysis(
                    `?institutionType=${e.target.value}&dateFrom=${dateFrom}&dateTo=${dateTo}&indicatorLastPeriod=${secondsEnter}&reportType=indicator`
                  );

                  setInstitutionType(e.target.value);
                }}
              >
                <option value="" selected>
                  All
                </option>
                <option value="bank">Bank Institutions</option>
                <option value="nonBank">Non-Bank Institutions</option>
              </select>
              <svg
                className="icon"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M8.69891 11.4136L11.2385 14.0036C11.6209 14.3936 12.2386 14.3936 12.621 14.0036L15.1606 11.4136C15.7783 10.7836 15.3371 9.70361 14.4644 9.70361H9.38528C8.51261 9.70361 8.08117 10.7836 8.69891 11.4136Z"
                  fill="#019EDF"
                />
              </svg>
            </SelectInput>
          </div>
          <Head>
            <div className="top">
              <p>Site Performance Indicator</p>
              <span>Today, {formatTime(secondsEnter2)} ago</span>
            </div>
            <div className="timerate">
              <span
                onClick={() => {
                  setSecondsOpen(!secondsOpen);
                  setDateFilter(false);
                }}
                style={{ position: "relative", cursor: "pointer" }}
              >
                Filter By Last {secondsEnter} Seconds <AiOutlineDown />
                {secondsOpen && (
                  <DropDown
                    onClick={(e) => {
                      e.stopPropagation();
                    }}
                    style={{ cursor: "default", width: "300px" }}
                  >
                    <div className="title" style={{ padding: "10px 0" }}>
                      Fetch Time Frame
                    </div>
                    <form
                      onSubmit={() => {
                        if (secondsEnter >= 300) {
                          getDashboardAnalysis2(
                            `?indicatorLastPeriod=${secondsEnter}${
                              institutionType
                                ? `&institutionType=${institutionType}`
                                : ""
                            }&reportType=indicator`
                          );

                          setSecondsEnter2(secondsEnter);
                        } else {
                          toast.error("Must not be less than 15 seconds");
                        }
                      }}
                    >
                      <FormInput
                        onChange={(e) => {
                          setSecondsEnter(e.target.value);
                        }}
                        type="number"
                        background="#F2F7FF"
                        padding="10px 14px"
                        placeholder="Enter Seconds"
                      />
                    </form>
                    <svg
                      style={{
                        position: "absolute",
                        top: "50%",
                        right: "30px",
                        transform: "translateY(50%)",
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        if (secondsEnter >= 300) {
                          getDashboardAnalysis2(
                            `?institutionType=${institutionType}&indicatorLastPeriod=${secondsEnter}&reportType=indicator`
                          );

                          setSecondsEnter2(secondsEnter);
                        } else {
                          toast.error("Must not be less than 15 seconds");
                        }
                      }}
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      {/* hekk */}
                      <g clip-path="url(#clip0_505_4722)">
                        <path
                          d="M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z"
                          fill="#00B3FE"
                        />
                        <path
                          d="M15.1196 9.12419C13.979 7.98365 12.8387 6.84311 11.6981 5.70258C10.6189 4.62314 8.95014 6.30466 10.0321 7.38663C10.497 7.85149 10.9619 8.31638 11.4267 8.78141C9.59614 8.78141 7.76556 8.78141 5.93516 8.78141C4.40556 8.78141 4.39213 11.1506 5.9181 11.1506C7.7545 11.1506 9.5909 11.1506 11.4272 11.1506C10.9592 11.6186 10.4911 12.0866 10.0231 12.5547C8.94368 13.6339 10.6252 15.3027 11.7072 14.2207C12.8477 13.0803 13.9881 11.94 15.1286 10.7994C15.5865 10.3413 15.574 9.57849 15.1196 9.12419Z"
                          fill="white"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_505_4722">
                          <rect width="20" height="20" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                  </DropDown>
                )}
              </span>
            </div>
          </Head>
          {handleCheckMetric(
            "sitePerformance",
            userData?.userDetail?.metrics
          ) && (
            <>
              <Head>
                <div
                  className="top"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    width: "100%",
                  }}
                >
                  <p style={{ margin: "10px 0" }}>Response Time</p>
                </div>
              </Head>{" "}
              {loading && <Skeleton2 height="30px" />}
              {loading ? (
                <Skeleton2 />
              ) : (
                sitePerformanceIndicator && (
                  <GaugeStyle>
                    {sitePerformanceIndicator?.map((item) => {
                      return (
                        <div className="gauge">
                          <GaugeChart
                            id="gauge-chart3"
                            nrOfLevels={30}
                            colors={["#37ffa8", "#FFC371", "#EA4228"]}
                            arcWidth={0.3}
                            style={{ width: "100%" }}
                            textColor="#fd9c0a0"
                            hideText={true}
                            percent={
                              item?.averageSec > 45 ? 45 : item?.averageSec / 45
                            }
                          />
                          <div className="gauge_sec">{item?.averageSec}s</div>
                          <div className="gauge_text">{item?.institution}</div>
                        </div>
                      );
                    })}
                  </GaugeStyle>
                )
              )}
              <div
                style={{
                  color: "#a7a7a7",
                  marginBottom: "40px",
                  fontSize: "16px",
                }}
              >
                {loading ? (
                  <Skeleton2 height="30px" />
                ) : (
                  sitePerformanceIndicator?.length === 0 &&
                  "No Response Time Data"
                )}
              </div>
            </>
          )}
        </>
      )}
      {/* hhh */}
    </DashboardLayout>
  );
}

const SelectInput = styled.div`
  position: relative;
  width: 300px;
  margin-left: auto;

  select {
    width: 100%;
    height: 100%;
    appearance: none;
    border-radius: 20px;
    outline: none;
    padding: 10px;
    font-size: 16px;
    background-color: white;
    margin-bottom: 20px;
    border: 1px solid #e6e7ec;
    color: #019edf;
  }
  .icon {
    position: absolute;
    top: 50%;
    right: 10px;
    transform: translateY(-90%);
    pointer-events: none;
  }
`;
const Head = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 30px;
  .top p {
    font-size: 30px;
    font-weight: 500;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .top span {
    font-size: 15px;
    color: #00a2e5;
    font-weight: 500;
  }
  .timerate {
    display: flex;
    align-items: center;
    gap: 20px;
  }
  .timerate span {
    font-size: 16px;
    display: flex;
    align-items: center;
    gap: 8px;
  }
  .timerate p {
    font-size: 12.5px;
    display: flex;
    align-items: center;
    gap: 15px;
  }
`;

const GaugeStyle = styled.div`
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  width: 100%;
  overflow: hidden;
  overflow-x: scroll;

  &::-webkit-scrollbar {
    width: 0px;
  }

  .gauge {
    text-align: center;
    position: relative;
    width: 260px;

    .gauge_text {
      color: #000000;
      font-size: 15px;
      font-weight: 500;
    }
    .gauge_sec {
      color: #000;
      position: absolute;
      top: 60%;
      left: 50%;
      transform: translate(-50%, -90%);
      z-index: 100;
      font-size: 16px;
      padding: 2px;
      background-color: #f5fcff;
    }
  }
`;

const DropDown = styled.div`
  position: absolute;
  border: 1px solid #bbbbbb;
  border-radius: 20px;
  top: 180%;
  right: 0;
  background-color: white;
  z-index: 100;
  padding: 0 20px;
  padding-top: 8px;
  width: 220%;
  text-transform: capitalize;
  font-size: 14px;

  .title {
    border-bottom: 1px solid #e9e9e9;
    width: 100%;
    font-size: 14px;
    margin-bottom: 20px;
  }
`;
